<template>
  <div>
    <portal to="page-top-title">Subject #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'subjects-edit', params: { id: id } }" icon="fa-edit" text>Edit</btn>
    </portal>

    <box-single :url="`/subjects/${id}`" data-prop="subject" resp-prop="data" loader>
      <template slot="content">
        <row>
          <column-info title="Name">{{ subject.name }}</column-info>
          <column-info title="Category">
            <router-link :to="{ name: 'subjects-categories-single', params: { id: subject.category.id } }">{{ subject.category.name }}</router-link>
          </column-info>
          <column-info title="Created At">{{ subject.created_at }}</column-info>
          <column-info title="Updated At">{{ subject.updated_at }}</column-info>
        </row>
        <row>
          <column-info title="Active">
            <badge-active :value="subject.active"/>
          </column-info>
        </row>
        <row>
          <column-info title="Value" :md="12" :sm="12">{{ subject.value }}</column-info>
        </row>
        <row>
          <column-info title="Value with Shortcodes" :md="12" :sm="12">
            <nullable :value="subject.value_with_codes"/>
          </column-info>
        </row>
      </template>
    </box-single>
  </div>
</template>

<script>
import BoxSingle from '@/views/components/data/BoxSingle'
import BadgeActive from '@/views/components/simple/BadgeActive'
import Nullable from '@/views/components/simple/Nullable'
import Btn from '@/views/components/simple/Btn'
import subject from '@/modules/strubs/subject'

export default {
  name: 'SubjectsSingle',
  metaInfo () {
    return { title: 'Subject #' + this.id }
  },
  components: {
    Nullable,
    BoxSingle,
    BadgeActive,
    Btn
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      subject: subject
    }
  }
}
</script>
